export var WithdrawPointType;
(function (WithdrawPointType) {
    WithdrawPointType["DEPOSIT"] = "deposit";
    WithdrawPointType["AGENT_TRANSFER_DEPOSIT"] = "agent_transfer_deposit";
    WithdrawPointType["THIRD_PARTY_DEPOSIT"] = "third_party_deposit";
    WithdrawPointType["MANUAL_DEPOSIT"] = "manual_deposit";
    WithdrawPointType["WITHDRAW"] = "withdraw";
    WithdrawPointType["MANUAL_WITHDRAW"] = "manual_withdraw";
    WithdrawPointType["ACTIVITY"] = "activity";
    WithdrawPointType["AGENT_DISPATCH"] = "agent_dispatch";
    WithdrawPointType["BET_CHANGED"] = "bet_changed";
    WithdrawPointType["ADMIN"] = "admin";
    WithdrawPointType["FEEDBACK"] = "feedback";
})(WithdrawPointType || (WithdrawPointType = {}));
//# sourceMappingURL=WithdrawPointType.js.map